import apiClient from './apiClient';

export async function login(email, password) {
  const res = await apiClient.post('/auth/login', { email, password });
  return res.data.data; // { accessToken, user }
}

export async function refreshSession() {
  const res = await apiClient.post('/auth/refresh');
  return res.data.data; // { accessToken }
}

export async function logout() {
  await apiClient.post('/auth/logout');
}

export async function getMe() {
  const res = await apiClient.get('/auth/me');
  return res.data.data;
}

export async function changePassword(currentPassword, newPassword) {
  const res = await apiClient.post('/auth/change-password', { currentPassword, newPassword });
  return res.data.data;
}

export async function forgotPassword(email) {
  const res = await apiClient.post('/auth/forgot-password', { email });
  return res.data.data;
}

export async function verifyResetOtp(email, otp) {
  const res = await apiClient.post('/auth/verify-reset-otp', { email, otp });
  return res.data.data;
}

export async function resetPassword(resetToken, newPassword) {
  const res = await apiClient.post('/auth/reset-password', { resetToken, newPassword });
  return res.data.data;
}
